const formatDateTime = (isoString) => {
    const date = new Date(isoString); // Parses the ISO string

    // Convert to Indian Standard Time (IST)
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istDate = new Date(date.getTime() + istOffset);

    // Extracting IST Date
    const day = String(istDate.getUTCDate()).padStart(2, '0');
    const month = String(istDate.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = istDate.getUTCFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Extracting IST Time
    let hours = istDate.getUTCHours();
    const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(istDate.getUTCSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;

    return `${formattedDate} ${formattedTime}`;
};

module.exports = formatDateTime;
